import classNames from 'classnames';
import Typography from '@/components/atoms/typography/typography';
import useCurrencyFormatter from '@/libraries/formatters/use-currency-formatter';
import styles from './price-items.module.scss';

export interface PriceItemsProps {
  /** The class name to apply */
  className?: string;
  /** Price items to display */
  priceItems: Content.Components['PriceItemDto'][];
}

const PriceItems = ({ className, priceItems = [] }: PriceItemsProps) => {
  const currencyFormatter = useCurrencyFormatter();

  return (
    <div className={classNames(styles.component, className)}>
      {priceItems
        .filter(item => item.price !== 0)
        .map((priceItem, priceItemIndex) => (
          <div key={priceItemIndex} className={styles.priceItem}>
            <Typography tagStyle="labelSmall">{priceItem.label}</Typography>

            <div className={styles.discountPriceWrapper}>
              {priceItem.normalPrice !== 0 && (
                <Typography className={styles.normalPrice} tagStyle="bodySmall">
                  {currencyFormatter(priceItem.normalPrice)}
                </Typography>
              )}

              {priceItem.price && (
                <Typography tagStyle="priceSmall">
                  {`${priceItem.fromText && priceItem.fromText} ${currencyFormatter(priceItem.price)}`}
                </Typography>
              )}
            </div>
          </div>
        ))}
    </div>
  );
};

PriceItems.displayName = 'PriceItems';

export default PriceItems;
